module.exports = __webpack_public_path__ + "media/dashboard/assets/images/dial-pad-white-7a797392c1c084c6e3ac17e28eaead26.svg";